import { render, staticRenderFns } from "./Section-01.vue?vue&type=template&id=1c3707e6&scoped=true&"
import script from "./Section-01.vue?vue&type=script&lang=js&"
export * from "./Section-01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3707e6",
  null
  
)

export default component.exports